import React from "react";
import { Link as LINK } from "@/types/global";
import { getValidUrl } from "@/utils/helper/string";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";

interface CustomLinkProps {
  link: LINK;
  className?: string;
  variant?: "default" | "header";
  disabled?: boolean;
}

export const TruncatedTextLinkWithPopup: React.FC<CustomLinkProps> = ({ link, className, variant = "default", disabled = false }) => {
  const baseClasses = "text-blue-600 hover:underline px-1";
  const headerClasses =
    "flex justify-center hover:text-white hover:bg-brand-secondary items-center py-1.5 px-4 rounded border border-text-primary bg-brand-light text-brand-primary text-13 !leading-5 transition-all duration-500 active:bg-brand-dark active:ring-brand-shade active:ring-offset-1 active:text-white ";
  const linkClasses = variant === "header" ? headerClasses : baseClasses;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const maxLength = 30;
  const stringValue = String(link.text);
  const isTruncated = stringValue.length > maxLength;
  const displayValue = isTruncated ? stringValue.slice(0, maxLength) + "..." : stringValue;
  const anchor = (
    <a
      href={disabled ? undefined : getValidUrl(link.value)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      className={` ${disabled ? "pointer-events-none opacity-50 cursor-not-allowed" : ""}`}
    >
      <span className={`${linkClasses} ${className} !text-blue-500`}>{displayValue}</span>
    </a>
  );

  if (isTruncated) {
    return (
      <Tippy content={stringValue} animation="fade" theme="light" className="text-wrap">
        {anchor}
      </Tippy>
    );
  }
  return anchor;
};
